
import { listItems } from './list-item.reducer';
import { listSelection } from './list-selection.reducer';
import { listRequest } from './list-request.reducer';
import { listFilterBy } from './list-filter.reducer';
import { listColumnReducer } from './list-column.reducer';
import { reduceReducers } from '@core/utils/state';
import { listArrangeBy } from './list-arrange-reducer';

export const reducer = reduceReducers(
  listItems,
  listRequest,
  listSelection,
  listFilterBy,
  listArrangeBy,
  listColumnReducer
);
